import { render, staticRenderFns } from "./legacyWorkbench.vue?vue&type=template&id=56fd39f0&scoped=true"
import script from "./legacyWorkbench.vue?vue&type=script&lang=js"
export * from "./legacyWorkbench.vue?vue&type=script&lang=js"
import style0 from "./legacyWorkbench.vue?vue&type=style&index=0&id=56fd39f0&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56fd39f0",
  null
  
)

export default component.exports